import { CircularProgress } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import axiosHandler from "../../../utils/axiosHandler.ts";
import { OrderSummaryPage } from "../../../federation/pages";

const OrderSummary = () => {
  const navigate = useNavigate();

  return (
    <React.Suspense fallback={<CircularProgress />}>
      <OrderSummaryPage axiosHandler={axiosHandler} navigate={navigate} />
    </React.Suspense>
  );
};

export default OrderSummary;
